<template>
  <div class="card-view-number">
    <div>
      <div>Целевые:</div>
      <div>Выплаты:</div>
    </div>
    <div>
      <div><b>Min</b>: {{ scale.target_a }}</div>
      <div><b>Min</b>: {{ scale.pay_a }}</div>
    </div>
    <div>
      <div><b>Target</b>: {{ scale.target_b }}</div>
      <div><b>Target</b>: {{ scale.pay_b }}</div>
    </div>
    <div>
      <div><b>Max</b>: {{ scale.target_c }}</div>
      <div><b>Max</b>: {{ scale.pay_c }}</div>
    </div>
  </div>
</template>

<script>

import {dynamicScaleComponent} from "@/mixins/dynamicScaleComponent";

export default {
  name: "card-view",
  mixins: [dynamicScaleComponent],
  components: {},

  props: {},

  data() {
    return {
      scale: {
        target_a: null,
        target_b: null,
        target_c: null,
        pay_a: null,
        pay_b: null,
        pay_c: null,
      },
    }
  },
  mounted() {

  },
  computed: {},
  methods: {}
}
</script>

<style>
.card-view-number {
  display: flex;
  justify-content: space-between;
}
</style>